import katex from 'katex'

/**
 * Render a string that may contain LaTeX math expressions.
 * Supports both inline ($...$) and display ($$...$$) math.
 */
export function renderLatex(text: string): string {
  if (!text) return text

  // First handle display math ($$...$$)
  let result = text.replace(/\$\$([^$]+)\$\$/g, (_, math) => {
    try {
      return katex.renderToString(math.trim(), {
        displayMode: true,
        throwOnError: false,
        output: 'html',
      })
    } catch {
      return `$$${math}$$`
    }
  })

  // Then handle inline math ($...$)
  result = result.replace(/\$([^$]+)\$/g, (_, math) => {
    try {
      return katex.renderToString(math.trim(), {
        displayMode: false,
        throwOnError: false,
        output: 'html',
      })
    } catch {
      return `$${math}$`
    }
  })

  return result
}

/**
 * React component to render text with LaTeX support
 */
interface LatexTextProps {
  children: string
  className?: string
  as?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'div'
}

export function LatexText({ children, className = '', as: Tag = 'span' }: LatexTextProps) {
  const html = renderLatex(children)
  
  return (
    <Tag 
      className={className}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}

/**
 * Check if text contains LaTeX
 */
export function hasLatex(text: string): boolean {
  return /\$[^$]+\$/.test(text)
}








